import { useEffect, useMemo } from "react";
import { useAppSelector } from "../redux/hooks";

export default function TitleUpdater() {
  const { data: siteContent, fetchLoading } = useAppSelector(
    (state) => state.siteContent
  );

  // Memoized extraction of restaurant info
  const { restaurantName, logoUrl } = useMemo(() => {
    const navWidget = siteContent?.navWidgets?.find((w) =>
      w.type?.includes("Nav")
    );

    return {
      restaurantName: navWidget?.data?.logoText?.trim() || "Loading",
      logoUrl: navWidget?.data?.logoUrl || null,
    };
  }, [siteContent]);

  // Update page title
  useEffect(() => {
    if (!fetchLoading && restaurantName) {
      const prevTitle = document.title;
      if (prevTitle !== restaurantName) {
        document.title = restaurantName;
      }
    }
  }, [restaurantName, fetchLoading]);

  // Update favicon
  useEffect(() => {
    if (!logoUrl) return;

    const link =
      document.querySelector<HTMLLinkElement>("link[rel*='icon']") ||
      document.createElement("link");

    if (!link.parentNode) {
      link.rel = "icon";
      document.head.appendChild(link);
    }

    // Only update if different
    if (link.href !== logoUrl) {
      link.href = logoUrl;
    }
  }, [logoUrl]);

  return null;
}
